/**
 * @file New-property coach: creates the owner, unit, tenant and concept contract, and the contract's 201 or 207 closes it onto that contract's page.
 * Failure path: any other answer keeps it on its step, its fields marked from the coach's own state, so Finish can retry.
 */
import * as React from "react";
import Component from "../../AbstractComponent";
import { getLabelForField } from "../../../Entity/Entities/Contract/FieldLabels";
// import Dialog from '@material-ui/core/Dialog';
// import Stepper from '@material-ui/core/Stepper';
// import Step from '@material-ui/core/Step';
// import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import TextField from "../Material/TextField";
import Constants from "../../../Action/Constants";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Select from "../Material/Select";
import PaymentRouteRadio from "../Charge/PaymentRouteRadio";
import {
  PAYMENT_ROUTE,
  PaymentRouteId,
} from "../../../Entity/Entities/Charge/PaymentRoute";
import MenuItem from '@material-ui/core/MenuItem';
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import AgencyFeeContainer from "../../../Entity/Entities/AgencyFee/AgencyFeeContainer";
import UnitTypeContainer from "../../../Entity/Entities/Unit/UnitTypeContainer";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import { FirstDayOfPeriod } from "../../../Entity/Entities/Charge/PaymentOffset/Offsets/FirstDayOfPeriod";
import PeriodContainer from "../../../Entity/Entities/Charge/Period/PeriodContainer";
import CurrencyContainer from "../../../Currency/CurrencyContainer";
import Time from "../../../Time/Time";
import Formatter from "../../../Localization/Formatter";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { AddressSelector } from "../../Partials/AddressSelector/AddressSelector";
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { Occupant as OccupantType } from "../../../Entity/Entities/ContactForContract/Type/Types/Occupant";
import PersonFactory from "../../../Entity/Factories/PersonFactory";
import * as uuidV4 from "uuid/v4";
import AssignmentServiceStatusTypeContainer from "../../../Entity/Entities/Unit/ServiceStatus/AssignmentServiceStatusTypeContainer";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import CompanyLookup from "../../Partials/Lookup/CompanyLookup";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import ReactSelect from 'react-select';
import PropertyLookup from "../Lookup/PropertyLookup";

import { NewCoachWrapper } from "./NewCoach/NewCoachWrapper";
import { Title } from "./NewCoach/NewCoachComponents/Title";
import { Subtitle } from "./NewCoach/NewCoachComponents/Subtitle";
import { CoachSummaryTable } from "./NewCoach/NewCoachContents/CoachSummaryTable";

export class CoachNewPropertyFirstUserDialog extends Component {
  private shortContractWarningPeriod: number = 1000 * 60 * 60 * 24 * 5;

  public state = {
    activeStep: 0,
    skipped: new Set(),
    openNewPropertyFirstUserCoach: false,
    hasModifiedData: false,
    openLeavePrompt: false,
    disableButtonDuringRequest: false,
    errorFields: null,
    errorMessage: null,
    selectedProperty: null,
    unitNumber: "",
    squareMeters: "",
    roomNumber: "",
    bedroomNumber: "",
    bathroomNumber: "",
    publicationTitle: "",
    amazonFolderName: uuidV4(),
    scenario: "single",
    showNextButton: false,
    isSaving: false,

    //Owner data
    ownerType: "person",
    firstName: "",
    lastName: "",
    companyName: "",
    company: null,
    ownerChoise: "newowner",

    //Property data
    address: {
      formattedAddress: ""
    },
    property: null,
    propertyChoise: "newproperty",

    //Unit data
    unitType: UnitTypeContainer.pickIdFromLabel("Apartment"),
    unit: null,
    propertyId: null,

    //Tenant data
    tenant: null,
    tenantFirstName: "",
    tenantLastName: "",
    tenantType: "person",
    companyNameTenant: "",
    companyTenant: null,

    //Contract data
    contract: null,
    finalRentalPeriodDate: null,
    expirationDate: Time.substractMonth(Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()), this.props.app.settings.agency.notificationPeriod),
    lastDate: Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()),
    status: this.props.app.contractStatuses['CONCEPT'],
    note: "",
    firstDate: Time.firstDateCurrentMonth(),
    isCommercial: false,
    referenceForTenant: "",
    autoSendInvoiceToTenant: false,

    //Occupant data
    occupantFirstName: "",
    occupantLastName: "",
    occupantDescription: this.trans("title-occupant"),
    occupantError: null,
    occupantsData: [],
    showAdditionalSection: false,

    //Complex data
    complexName: "",
    complexUnits: [],
    complexNameAdded: false,
    complexNameError: false,

    //Charge template data
    amount: "",
    paymentRouteId: PAYMENT_ROUTE.AGENCY,
    isDefault: !!this.props.shouldCreateDefault,
    currency: this.props.app.settings.user.currency.getCurrencyId(),
    repeatPeriod: this.props.selectedType === TypeContainer.pickIdFromLabel("Deposit") ? PeriodContainer.pickIdFromLabel("once") : PeriodContainer.pickIdFromLabel("monthly"),
    description: "",
    paymentOffset: FirstDayOfPeriod.value,
    type: this.props.selectedType ? this.props.selectedType : TypeContainer.pickIdFromLabel("Basic_rent"),
    dueDateFirstPayment: Time.firstDateNextMonth(),
    dueDateFirstPaymentWasManuallyChanged: false,
    endDate: this.props.endDate ? this.props.endDate : null,
    isCreateChargeTypePopupOpen: false,
    isCollective: true,
    chargeTemplates: [],
    errorAmountTemplate: false,
    showChargeTemplateFields: true,

    //Agreement data
    agreement: null,
    fixedFee: "",
    percentageFee: "0",
    fixedPlusPercentageMode: this.props.globalTypes?.FixedPlusPercentageModes?.[this.defaultFixedPlusPercentageModes("FPP_both")],
    vat: "",
    vatPercentage: "",
    dateChoice: "agreementFirstDate",
    firstDateError: "",
    chargeTypeIds: [TypeContainer.pickIdFromLabel("Basic_rent")],
    objectType: AgencyFeeContainer.pickIdFromLabel("Unit"),
    objectId: null,
    inheritAgencyFee: null,
    changeFixedFeeManual: false,
    changePercentageFeeManual: false,
    isClosePreprocessDialogOpen: false,
    assignmentRepeatPeriod: PeriodContainer.pickIdFromLabel("monthly"),
    assignmentServiceStatus: AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial"),
    dateForAgreement: Time.firstDateNextMonth(),
    agreementFirstDate: Time.firstDateCurrentMonth()
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    if (this.props.propertyCreateByCoach) {
      this.setState({
        inheritAgencyFee: null,
        selectedProperty: this.props.propertyCreateByCoach,
      });
    }

    this.setState({
      openNewPropertyFirstUserCoach: this.props.openNewPropertyFirstUserCoach,
    });
  }

  public componentWillReceiveProps(nextProps) {
    if (nextProps.propertyCreateByCoach) {
      this.setState({
        inheritAgencyFee: null,
        selectedProperty: nextProps.propertyCreateByCoach
      });
    }
    this.setState({
      openNewPropertyFirstUserCoach: nextProps.openNewPropertyFirstUserCoach,
    });
  }

  public clearState = () => {
    this.clearBackEndErrors();

    this.setState({
      activeStep: 0,
      skipped: new Set(),
      openNewPropertyFirstUserCoach: false,
      hasModifiedData: false,
      openLeavePrompt: false,
      disableButtonDuringRequest: false,
      errorFields: null,
      errorMessage: null,
      selectedProperty: null,
      unitNumber: "",
      squareMeters: "",
      roomNumber: "",
      bedroomNumber: "",
      bathroomNumber: "",
      publicationTitle: "",
      amazonFolderName: uuidV4(),
      scenario: "single",
      showNextButton: false,
      isSaving: false,

      //Owner data
      ownerType: "person",
      firstName: "",
      lastName: "",
      companyName: "",
      company: null,
      ownerChoise: "newowner",

      //Property data
      address: {
        formattedAddress: ""
      },
      property: null,
      propertyChoise: "newproperty",

      //Unit data
      unitType: UnitTypeContainer.pickIdFromLabel("Apartment"),
      unit: null,
      propertyId: null,

      //Tenant data
      tenant: null,
      tenantFirstName: "",
      tenantLastName: "",
      tenantType: "person",
      companyNameTenant: "",
      companyTenant: null,

      //Contract data
      contract: null,
      finalRentalPeriodDate: null,
      expirationDate: Time.substractMonth(Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()), this.props.app.settings.agency.notificationPeriod),
      lastDate: Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()),
      status: this.props.app.contractStatuses['CONCEPT'],
      note: "",
      firstDate: Time.firstDateCurrentMonth(),

      //Occupant data
      occupantFirstName: "",
      occupantLastName: "",
      occupantDescription: this.trans("title-occupant"),
      occupantError: null,
      occupantsData: [],
      showAdditionalSection: false,

      //Complex data
      complexName: "",
      complexUnits: [],
      complexNameAdded: false,
      complexNameError: false,

      //Charge template data
      amount: "",
      paymentRouteId: PAYMENT_ROUTE.AGENCY,
      isDefault: !!this.props.shouldCreateDefault,
      currency: this.props.app.settings.user.currency.getCurrencyId(),
      repeatPeriod: this.props.selectedType === TypeContainer.pickIdFromLabel("Deposit") ? PeriodContainer.pickIdFromLabel("once") : PeriodContainer.pickIdFromLabel("monthly"),
      description: "",
      paymentOffset: FirstDayOfPeriod.value,
      type: this.props.selectedType ? this.props.selectedType : TypeContainer.pickIdFromLabel("Basic_rent"),
      dueDateFirstPayment: Time.firstDateNextMonth(),
      dueDateFirstPaymentWasManuallyChanged: false,
      endDate: this.props.endDate ? this.props.endDate : null,
      isCreateChargeTypePopupOpen: false,
      isCollective: true,
      chargeTemplates: [],
      errorAmountTemplate: false,
      showChargeTemplateFields: true,

      //Agreement data
      agreement: null,
      fixedFee: "",
      percentageFee: "0",
      fixedPlusPercentageMode: this.props.globalTypes?.FixedPlusPercentageModes?.[this.defaultFixedPlusPercentageModes("FPP_both")],
      vat: "",
      vatPercentage: "",
      dateChoice: "agreementFirstDate",
      firstDateError: "",
      chargeTypeIds: [TypeContainer.pickIdFromLabel("Basic_rent")],
      objectType: AgencyFeeContainer.pickIdFromLabel("Unit"),
      objectId: null,
      inheritAgencyFee: null,
      changeFixedFeeManual: false,
      changePercentageFeeManual: false,
      isClosePreprocessDialogOpen: false,
      assignmentRepeatPeriod: PeriodContainer.pickIdFromLabel("monthly"),
      assignmentServiceStatus: AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial"),
      dateForAgreement: Time.firstDateNextMonth(),
      agreementFirstDate: Time.firstDateCurrentMonth()
    });
  }

  public clearAgencyFeeState = () => {
    this.setState({
      //Agreement data
      fixedFee: "",
      percentageFee: "0",
      fixedPlusPercentageMode: this.props.globalTypes?.FixedPlusPercentageModes?.[this.defaultFixedPlusPercentageModes("FPP_both")],
      vat: "",
      vatPercentage: "",
      dateChoice: "agreementFirstDate",
      firstDateError: "",
      chargeTypeIds: [TypeContainer.pickIdFromLabel("Basic_rent")],
      objectType: AgencyFeeContainer.pickIdFromLabel("Unit"),
      objectId: null,
      inheritAgencyFee: null,
      changeFixedFeeManual: false,
      changePercentageFeeManual: false,
      isClosePreprocessDialogOpen: false,
      assignmentRepeatPeriod: PeriodContainer.pickIdFromLabel("monthly"),
      assignmentServiceStatus: AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial"),
      dateForAgreement: Time.firstDateNextMonth(),
    });
  }

  protected getErrorFor(
    field: string,
    errorFields: string[] = this.state.errorFields || [],
    translatedMessage: string = this.state.errorMessage,
    displayName: string = this.getLabelFor(field)
  ): any {
    return super.getErrorFor(field, errorFields, translatedMessage, displayName);
  }

  public getLabelFor = (field: string): string => {
    return getLabelForField(field, this.trans);
  }

  // The control's `id`, `name`, scroll class and backend error, all from its request-body path.
  public getFieldPropsFor = (path: string) => {
    return {
      id: path,
      name: path,
      className: `scroll-to-${path}`,
      error: this.getErrorFor(path)
    };
  }

  public onCloseNewPropertyFirstUser = () => {
    setTimeout(() => { this.clearState() }, 100);

    if (this.props.onCloseNewPropertyFirstUser) {
      this.props.onCloseNewPropertyFirstUser.call(this);
    }
  }

  /* Main logic for STEPPER */
  // Logic for stepper, use methods when we click button continue on step page, and we start logic.
  public handleNext = () => {
    const { activeStep } = this.state;
    const steps = this.getSteps();

    if (activeStep === steps.length - 1) { // it is last step
      this.onCloseNewPropertyFirstUser();
      this.redirect(`/app/dashboard/overview`);
    } else {
      this.setState({
        showNextButton: false
      }, () => {
        switch (activeStep) {
          case 0:
            return this.plusOneStep();
          case 1:
            if (!this.state.showNextButton && !this.state.company) {
              return this.createOwner();
            }

            return this.plusOneStep();
          case 2:
            if (!this.state.showNextButton && !this.state.unit) {
              return this.createUnit();
            }

            return this.plusOneStep();
          case 3:
            if (!this.state.showNextButton && !this.state.agreement) {
              return this.createAgreement();
            }

            return this.plusOneStep();
          case 4:
            if (!this.state.showNextButton && !this.state.tenant && !this.state.companyTenant) {
              if (this.state.showAdditionalSection) {
                return this.addNewOccupant(this.createTenant);
              }

              return this.createTenant();
            }

            return this.plusOneStep();
          case 5:
            if (!this.state.showNextButton && !this.state.contract) {
              if (this.state.showChargeTemplateFields) {
                return this.addChargeTemplate(this.createContract);
              }

              return this.createContract();
            }
            this.createContract();
            this.addChargeTemplate(this.createContract);

            return this.setState({ showNextButton: true }, this.plusOneStep);
          case 6:
            return this.plusOneStep();
          case 7:
            return this.plusOneStep();
        }
      })
    }
  };


  //Funcionality for steps
  public startStep1 = () => {
    return this.agencyStartStepFirst();
  }

  public startStep2 = () => {
    return this.agencyStartStepSecond();
  }

  public startStep3 = () => {
    return this.agencyStartStepThird();
  }

  public startStep4 = () => {
    return this.agencyStartStepForth();
  }

  public startStep5 = () => {
    return this.agencyStartStepFifth();
  }

  public startStep6 = () => {
    return this.createContract();
  }

  //Methods for step logic
  public agencyStartStepFirst = () => {
    this.plusOneStep();
  }

  public agencyStartStepSecond = () => {
    this.plusOneStep();
  }

  public agencyStartStepThird = () => {
    this.plusOneStep();
  }

  public agencyStartStepForth = () => {
    this.plusOneStep();
  }

  public agencyStartStepFifth = () => {
    this.plusOneStep();
  }

  public plusOneStep = () => {
    const { activeStep } = this.state;

    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    if (this.state.scenario === "single") {
      return [this.trans("coach/newpropertyfirstuser-scenario/single-step/first-title"), this.trans("coach/newpropertyfirstuser-scenario/single-step/second-title"), this.trans("coach/newpropertyfirstuser-scenario/single-step/third-title"), this.trans("coach/newpropertyfirstuser-scenario/single-step/fourth-title"), this.trans("coach/newpropertyfirstuser-scenario/single-step/fifth-title"), this.trans("coach/newpropertyfirstuser-scenario/single-step/sixth-title")];
    } else if (this.state.scenario === "multiple") {
      return [this.trans("coach/newpropertyfirstuser-scenario/single-step/first-title"), this.trans("coach/newpropertyfirstuser-scenario/single-step/second-title"), this.trans("coach/newpropertyfirstuser-scenario/single-step/third-title"), this.trans("coach/newpropertyfirstuser-scenario/single-step/fourth-title"), this.trans("coach/newpropertyfirstuser-scenario/single-step/fifth-title"), this.trans("coach/newpropertyfirstuser-scenario/single-step/sixth-title")];
    } else if (this.state.scenario === "complex") {
      return [this.trans("coach/newpropertyfirstuser-scenario/single-step/first-title"), this.trans("coach/newpropertyfirstuser-scenario/single-step/second-title"), this.trans("coach/newpropertyfirstuser-scenario/single-step/third-title"), this.trans("coach/newpropertyfirstuser-scenario/single-step/fourth-title"), this.trans("coach/newpropertyfirstuser-scenario/single-step/fifth-title"), this.trans("coach/newpropertyfirstuser-scenario/single-step/sixth-title")];
    }
  }

  //All components with content for steps we have here
  public getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.stepContent(step);
      case 1:
        return this.stepContent(step);
      case 2:
        return this.stepContent(step);
      case 3:
        return this.stepContent(step);
      case 4:
        return this.stepContent(step);
      case 5:
        return this.stepContent(step);
      default:
        return this.trans("unknown-step");
    }
  }

  // Content details for diffenrent steps.
  public stepContent = (step) => {
    return (
      <div>
        {step === 0 && this.firstStepDetails()}
        {step === 1 && this.secondStepDetails()}
        {step === 2 && this.thirdStepDetails()}
        {step === 3 && this.fourthStepDetails()}
        {step === 4 && this.fifthStepDetails()}
        {step === 5 && this.sixthStepDetails()}
      </div>
    )
  }

  // Steppers components content
  public firstStepDetails = () => {
    return (
      <React.Fragment>
        <Title
          title={this.trans("coach/newpropertyfirstuser-step/first-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/newpropertyfirstuser-step/first-subtitle")}
        />

        <div className="image-radio-buttons-container" style={{ marginTop: "-15px" }}>
          <label className="label-wrapper">
            <input
              className="radio-item"
              type="radio"
              value="single"
              name="unit_type"
              checked={this.state.scenario === "single"}
              onChange={this.chooseScenario}
            />
            <div className="label-item">
              {this.image.getImage("coach_single_unit")}
            </div>
            <div className="info-text-gray center">
              {this.trans("coach/newpropertyfirstuser-radiobutton/single")}
            </div>
          </label>

          <label className="label-wrapper">
            <input
              className="radio-item"
              type="radio"
              value="multiple"
              name="unit_type"
              checked={this.state.scenario === "multiple"}
              onChange={this.chooseScenario}
            />
            <div className="label-item">
              {this.image.getImage("coach_multiple_units")}
            </div>
            <div className="info-text-gray center">
              {this.trans("coach/newpropertyfirstuser-radiobutton/multiple")}
            </div>
          </label>

          <label className="label-wrapper">
            <input
              className="radio-item"
              type="radio"
              value="complex"
              name="unit_type"
              checked={this.state.scenario === "complex"}
              onChange={this.chooseScenario}
            />
            <div className="label-item">
              {this.image.getImage("coach_complex")}
            </div>
            <div className="info-text-gray center">
              {this.trans("coach/newpropertyfirstuser-radiobutton/complex")}
            </div>
          </label>
        </div>
      </React.Fragment>
    )
  }

  public secondStepDetails = () => {
    switch (this.state.scenario) {
      case "single":
        return this.ownerStep();
      case "multiple":
        return this.ownerStep();
      case "complex":
        return this.ownerStep();
      default:
        return <div></div>
    }
  }

  public thirdStepDetails = () => {
    switch (this.state.scenario) {
      case "single":
        return this.unitStep("single");
      case "multiple":
        return this.unitStep("multiple");
      case "complex":
        return this.unitStep("complex");
      default:
        return <div></div>
    }
  }

  public fourthStepDetails = () => {
    switch (this.state.scenario) {
      case "single":
        return this.agreementStep();
      case "multiple":
        return this.agreementStep();
      case "complex":
        return this.agreementStep();
      default:
        return <div></div>
    }
  }

  public fifthStepDetails = () => {
    switch (this.state.scenario) {
      case "single":
        return this.tenantStep();
      case "multiple":
        return this.tenantStep();
      case "complex":
        return this.tenantStep();
      default:
        return <div></div>
    }
  }

  public sixthStepDetails = () => {
    switch (this.state.scenario) {
      case "single":
        return this.contractStep();
      case "multiple":
        return this.contractStep();
      case "complex":
        return this.contractStep();
      default:
        return <div></div>
    }
  }

  public changePropertyChoise = (event) => {
    this.clearBackEndErrors();

    const choice: string = event.target.value;

    this.setState({
      propertyChoise: choice,
      showNextButton: false,
      address: {
        formattedAddress: ""
      },
      property: null,

      selectedProperty: null,
      propertyId: null
    });
  }

  public changeOwnerChoise = (event) => {
    this.clearBackEndErrors();

    const choice: string = event.target.value;

    this.setState({
      ownerChoise: choice,
      firstName: "",
      showNextButton: false,
      company: null,
      companyName: "",
      lastName: ""
    });
  }

  public selectCompany = (company: CompanyInterface): void => {
    this.setState({
      company: company,
    }, () => {
      if (this.state.company) {
        this.setState({
          showNextButton: true
        })
      }
    });
  }

  public clearCompany = (): void => {
    this.setState({
      company: null
    }, () => {
      if (!this.state.company) {
        this.setState({
          showNextButton: false
        })
      }
    });
  }

  public ownerStepSummary = () => {
    let summaryArr = [{
      label: this.trans("coach/propertyowner-field/newperson-label"),
      value: `${this.state.firstName} ${this.state.lastName}`
    },
    {
      label: this.trans("coach/propertyowner-field/newcompany-label"),
      value: this.state.companyName
    }
    ];

    return summaryArr;
  }

  public ownerStep = () => {
    if (this.state.company && this.state.ownerChoise === "newowner") {
      return (
        <div className="coach-content-wrapper">
          <Title
            title={this.trans("coach/newpropertyfirstuser-step/landlord-title")}
          />
          <Subtitle
            subtitle={this.trans("coach/general-summary-create-subtitle-dutch-de", { entity: this.trans("label-landlord").toLowerCase() })}
          />
          <CoachSummaryTable
            tableRows={this.ownerStepSummary()}
          />
        </div>
      );
    } else {
      return (
        <div className="coach-content-wrapper">
          {
            this.props.app.companies.filter(company => !company.removed).length > 0 ?
              <Title
                title={this.trans("coach/newpropertyfirstuser-step/landlord-title")}
              />
              :
              <Title
                title={this.trans("coach/newpropertyfirstuser-step/owner-title")}
              />
          }

          <Subtitle
            subtitle={this.trans("coach/newunit-step/first-info1-subtitle")}
          />

          {
            // show only if there is more than 1 company in a system(1st is always the agency)
            this.props.app.companies.filter(company => !company.removed).length > 1 && (
              <div className="fields-wrapper">
                <div className="fields-inner-wrapper" style={{ display: "flex", justifyContent: "center" }}>
                  <RadioGroup
                    name="chargeOwnerChoice"
                    className="filters-container"
                    value={this.state.ownerChoise}
                    onChange={this.changeOwnerChoise}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      marginBottom: "15px",
                    }}
                  >
                    <FormControlLabel
                      control={<Radio color="primary" />}
                      value="newowner"
                      label={this.trans("coach/newunit-step/first-newowner/label")}
                      style={{ width: "auto", fontSize: "16px" }}
                    />

                    <FormControlLabel
                      control={<Radio color="primary" />}
                      value="existingowner"
                      label={this.trans("coach/newunit-step/first-selectexistingowner/label")}
                      style={{ width: "auto", fontSize: "16px" }}
                    />
                  </RadioGroup>
                </div>
              </div>
            )
          }

          {
            this.state.ownerChoise === "existingowner" ?
              <div className="fields-wrapper">
                <div className="fields-inner-wrapper">
                  <CompanyLookup
                    {...this.props}
                    id="companyId"
                    name="companyId"
                    className="scroll-to-companyId"
                    isInlineBlock={true}
                    width="100%"
                    containerWidth="100%"
                    styleInModal={"styleInModal"}
                    autoSelectId={this.state.company?.id}
                    ref="CompanyLookup"
                    floatingLabelText={this.trans("dropdown-searchforlandlord-label")}
                    labelText={this.trans("dropdown-owner-landlord")}
                    searchText={this.state.company ? this.state.company?.displayName : ""}
                    onSelect={this.selectCompany}
                    onClear={this.clearCompany}
                    noResultText={this.trans("dropdown-owner-notfound")}
                    error={this.getErrorFor("contacts.firstName") || this.getErrorFor("name")}
                    templateFor={"owner"}
                    filterAgency={true}
                    hideClickThroughLink={true}
                    disableEntityCreation={true}
                    autoFocus={true}
                  />
                </div>
              </div>
              :
              <React.Fragment>
                <div className="image-radio-buttons-container" style={{ marginTop: "-15px" }}>
                  <label className="label-wrapper">
                    <input
                      className="radio-item"
                      type="radio"
                      value="person"
                      name="owner_type"
                      checked={this.state.ownerType === "person"}
                      onChange={this.chooseOwnerType}
                    />
                    <div className="label-item">
                      {this.image.getImage("coach_person")}
                    </div>
                    <div className="info-text-gray center">
                      {this.trans("coach/propertyowner-radiobutton/person")}
                    </div>
                  </label>

                  <label className="label-wrapper">
                    <input
                      className="radio-item"
                      type="radio"
                      value="company"
                      name="owner_type"
                      checked={this.state.ownerType === "company"}
                      onChange={this.chooseOwnerType}
                    />
                    <div className="label-item">
                      {this.image.getImage("coach_company")}
                    </div>
                    <div className="info-text-gray center">
                      {this.trans("company")}
                    </div>
                  </label>
                </div>

                <div className="fields-wrapper">
                  <div className="fields-inner-wrapper">
                    <div className="hint-styles">
                      {this.trans("coach/propertyowner-scenario/company-step/first-info2")}
                    </div>
                    {
                      this.state.ownerType === "person" &&
                      <React.Fragment>
                        <TextField
                          autoComplete="off"
                          // id="firstName"
                          // name="firstName"
                          className="form-element full-size"
                          type="text"
                          label={this.trans("coach/propertyowner-scenario/person-step/second-field/firstname-label")}
                          value={this.state.firstName}
                          onChange={this.sync.bind(this, this.syncronizers.EVENT, "firstName")}
                          onBlur={this.onBlur}
                          autoFocus={true}
                          variant="standard"
                          error={!!this.getErrorFor("contacts.firstName")}
                          helperText={!!this.getErrorFor("contacts.firstName") && this.state.firstName.length === 0 ? this.trans("this-field-is-required") : this.getErrorFor("contacts.firstName")}
                        />

                        <TextField
                          autoComplete="off"
                          // id="lastName"
                          // name="lastName"
                          className="form-element full-size"
                          type="text"
                          label={this.trans("coach/propertyowner-scenario/person-step/second-field/lastname-label") + this.trans("field/optional")}
                          value={this.state.lastName}
                          onChange={this.sync.bind(this, this.syncronizers.EVENT, "lastName")}
                          onBlur={this.onBlur}
                          variant="standard"
                          error={!!this.getErrorFor("lastName")}
                          helperText={this.getErrorFor("lastName")}
                        />

                        <TextField
                          autoComplete="off"
                          className="form-element full-size"
                          type="text"
                          label={this.trans("coach/propertyowner-scenario/person-step/third-field/companyname-label")}
                          value={this.state.companyName}
                          onChange={this.sync.bind(this, this.syncronizers.EVENT, "companyName")}
                          variant="standard"
                          error={!!this.getErrorFor("name")}
                          helperText={this.getErrorFor("name")}
                        />

                        <div className="hint-styles">
                          {this.trans("coach/propertyowner-scenario/person-step/third-info2")}
                        </div>
                      </React.Fragment>
                    }
                    {
                      this.state.ownerType === "company" &&
                      <React.Fragment>
                        <TextField
                          autoComplete="off"
                          className="form-element full-size"
                          type="text"
                          label={this.trans("coach/propertyowner-scenario/person-step/third-field/companyname-label")}
                          value={this.state.companyName}
                          onChange={this.sync.bind(this, this.syncronizers.EVENT, "companyName")}
                          autoFocus={true}
                          variant="standard"
                          error={!!this.getErrorFor("name")}
                          helperText={!!this.getErrorFor("name") && this.state.companyName.length === 0 ? this.trans("this-field-is-required") : this.getErrorFor("name")}
                        />
                      </React.Fragment>
                    }
                    <div className="coach-new-property-save-button">
                      <Button
                        color="primary"
                        onClick={this.createOwner}
                        variant="contained"
                        style={{ textAlign: "right" }}
                      >
                        {this.trans("button-save")}
                      </Button>
                    </div>
                  </div>
                </div>
              </React.Fragment>
          }
          <div className="hint-styles center" style={{ marginTop: "30px", marginBottom: 0 }}>
            {this.trans("coach/propertyowner-scenario/person-step/last-hint")}
          </div>
        </div>
      )
    }
  }

  public unitStepSummary = () => {
    let summaryArr = [{
      label: this.trans("label-type"),
      value: this.trans(this.state.unit?.type?.label)
    },
    {
      label: this.trans("label-address"),
      value: this.state.unit?.displayName
    }
    ];

    return summaryArr;
  }

  public unitStep = (scenario) => {
    // We need to filter properties by company id, so we can see if this company has any properties or not
    const propertiesRelatedToOwner = Object.keys(this.props.properties?.byId || {}).map((id) => this.props.properties.byId[id])
      .filter(property => !!property)
      .filter(property => property.companyId === this.state.company?.id);

    if (this.state.unit) {
      return (
        <div className="coach-content-wrapper">
          <Title
            title={this.trans("coach/newpropertyfirstuser-step/unit-info1")}
          />
          <Subtitle
            subtitle={this.trans("coach/general-summary-create-subtitle-dutch-het", { entity: this.trans("title-unit").toLowerCase() })}
          />
          <CoachSummaryTable
            tableRows={this.unitStepSummary()}
          />
        </div>
      );
    } else {
      return (
        <div className="coach-content-wrapper">
          <Title
            title={this.trans("coach/newpropertyfirstuser-step/unit-info1")}
          />
          <Subtitle
            subtitle={this.trans("coach/newpropertyfirstuser-step/unit-info2")}
          />
          <div>
            {propertiesRelatedToOwner.length > 0 &&
              <RadioGroup
                name="chargePropertyChoice"
                className="filters-container"
                value={this.state.propertyChoise}
                onChange={this.changePropertyChoise}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  marginBottom: "15px",
                }}
              >
                <FormControlLabel
                  control={<Radio color="primary" />}
                  value="newproperty"
                  label={this.trans("coach/newunit-step/second-newproperty/label")}
                  style={{ width: "auto", fontSize: "16px" }}
                />

                <FormControlLabel
                  control={<Radio color="primary" />}
                  value="existingproperty"
                  label={this.trans("coach/newunit-step/second-selectexistingproperty/label")}
                  style={{ width: "auto", fontSize: "16px" }}
                />
              </RadioGroup>
            }
            {this.state.propertyChoise === "existingproperty" &&
              <PropertyLookup
                {...this.props}
                id="propertyId"
                name="propertyId"
                ref="PropertyLookup"
                className="scroll-to-propertyId"
                styleInModal={"styleInModal"}
                isInlineBlock={true}
                width="100%"
                containerWidth="100%"
                floatingLabelText={this.trans("dropdown-searchforaddress-label")}
                autoSelectId={this.state.property?.id}
                onSelect={this.handleCreatedProperty}
                onClear={this.clearProperty}
                error={!!this.getErrorFor("propertyId") && this.getErrorFor("propertyId")}
                templateFor={"property"}
                onlyPropertyRelatedOwner={this.state.company}
                disableEntityCreation={true}
                hideClickThroughLink={true}
                autoFocus={this.state.propertyChoise === "existingproperty"}
              />
            }
            {this.state.propertyChoise === "newproperty" && scenario === "complex" &&
              <React.Fragment>
                <TextField
                  autoComplete="off"
                  className="form-element full-size"
                  type="text"
                  label={this.trans("label-name")}
                  value={this.state.complexName}
                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "complexName")}
                  autoFocus={true}
                  variant="standard"
                  error={this.state.complexNameError}
                  helperText={this.state.complexNameError && this.trans("be_ajv_not_validated")}
                />
                <div className="hint-styles">
                  {this.trans("coach/newpropertyfirstuser-scenario/complex-info1")}
                </div>
              </React.Fragment>
            }
            {this.state.propertyChoise === "newproperty" &&
              <>
                <AddressSelector
                  {...this.props}
                  autoFocus={scenario !== "complex"}
                  id="address"
                  name="address.googlePlaceId"
                  className="scroll-to-address"
                  styleInModal={"styleInModal"}
                  searchText={this.state?.address?.formattedAddress ? this.state.address.formattedAddress : null}
                  selectedAddress={this.state.address}
                  onSelect={this.sync.bind(this, this.syncronizers.VALUE, "address")}
                  onClear={this.sync.bind(this, this.syncronizers.VALUE, "address", {})}
                  required={true}
                  error={this.getErrorFor("address.googlePlaceId")}
                  disabled={this.state.propertyId}
                />
                <div className="hint-styles">
                  {this.trans("coach/newpropertyfirstuser-step/fifth-hintforaddress")}
                </div>
              </>
            }
            <Select
              className="form-element full-size form-input scroll-to-unitTypeId correct-label-position"
              error={this.getErrorFor("unitTypeId")}
              value={this.state.unitType}
              onChange={this.sync.bind(this, this.syncronizers.UNIT_TYPE)}
              htmlFor="unitType"
              label={this.trans("unit-type")}
              name="unitType"
              id="unitType"
            >
              {this.getUnitTypeSelectboxes()}
            </Select>
              <>
                <TextField
                  autoComplete="off"
                  className="form-element full-size scroll-to-unitNumber"
                  type="text"
                  label={this.trans("unit-number")}
                  value={this.state.unitNumber}
                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "unitNumber")}
                  variant="standard"
                  error={!!this.getErrorFor("unitNumber")}
                />
                {!!this.getErrorFor("unitNumber") && <div className="component-error-text">{this.getErrorFor("unitNumber")}</div>}
                <div className="hint-styles">
                  {this.trans("coach/newpropertyfirstuser-step/forth-hintforunitnumber")}
                </div>
              </>

          </div>
          <div className="coach-new-property-save-button">
            <Button
              color="primary"
              onClick={this.createUnit}
              variant="contained"
              style={{ textAlign: "right" }}
            >
              {this.trans("button-save")}
            </Button>
          </div>
          <div className="hint-styles center" style={{ marginTop: "30px", marginBottom: 0 }}>
            {this.trans("coach/newpropertyfirstuser-step/forth-hintforunittype")}
          </div>
        </div>
      )
    }
  }

  public onChargeTypesSelectChange = (valArray) => {
    const types = !!valArray ? valArray.map(item => item.value) : [];

    this.setState({
      chargeTypeIds: [...types],
      hasModifiedData: true
    });
  }

  public renderChargeTypesSelect = () => {
    const chargeTypes = TypeContainer.getChargeTypesForChargeTemplates("agencyfee")
      .filter(type => {
        if (type.removed) {
          return false;
        }

        if (TypeContainer.pickIdFromLabel("Stub_receivable") === type.id || TypeContainer.pickIdFromLabel("Stub_payable") === type.id) {
          return false;
        }

        return true;
      })
      .map(type => {
        return ({
          value: type.id,
          label: this.formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)
        });
      }
      );

    const customStyles = {
      control: (base, state) => {
        let borderColor = 'rgba(0, 0, 0, 0.23)';
        let boxShadow = 'none !important';
        let outlineColor = "auto";

        if (state.isFocused) {
          borderColor = "#00BCD4 !important";
          boxShadow = "0 0 1px 1px #00BCD4 !important";
          outlineColor = "#00BCD4 !important";

          if (!!this.getErrorFor("chargeTypeIds")) {
            borderColor = "#f44336 !important";
            boxShadow = "0 0 1px 1px #f44336 !important";
            outlineColor = "#f44336 !important";
          }
        } else {
          if (!!this.getErrorFor("chargeTypeIds")) {
            borderColor = "#f44336 !important";
            outlineColor = "#f44336 !important";
          }
        }

        return ({
          ...base,
          border: state.isFocused ? 'none !important' : "auto",
          borderColor: borderColor,
          boxShadow: boxShadow,
          outlineColor: outlineColor,
          outlineStyle: state.isFocused ? "auto !important" : "auto",
          outlineWidth: state.isFocused ? "5px !important" : "auto",
          '&:hover': {
            borderColor: !!this.getErrorFor("chargeTypeIds") ? '#f44336' : 'black',
          }, // border style on hover
        });
      }
    }

    return (
      <div style={{ position: "relative", zIndex: 2 }}>
        <ReactSelect
          defaultValue={chargeTypes.find(type => type.value === TypeContainer.pickIdFromLabel("Basic_rent"))}
          isMulti
          options={chargeTypes}
          onChange={this.onChargeTypesSelectChange}
          styles={customStyles}
          placeholder={this.trans("dialog/agencyfee-field/chargetypes-label")}
          className="form-element scroll-to-charge-types"
        />
        {!!this.getErrorFor("chargeTypeIds") && <div className="component-error-text">{this.getErrorFor("chargeTypeIds")}</div>}
        <div className="hint-styles" style={{ margin: "-10px 0 10px 0" }}>
          {this.trans("dialog/agencyfee-info/chargetypes")}
        </div>
      </div>
    );
  }

  public agreementStepSummary = () => {
    let summaryArr = [{
      label: this.trans("title-start"),
      value: this.state.dateChoice === "agreementFirstDate" ? this.formatter.formatDate(this.state.agreementFirstDate) : this.trans("dialog/agencyfee-field/startfromcontractdate-label")
    },
    {
      label: this.trans("page/unitupdate-section/info-changeunitservicestatus/label"),
      value: this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(this.state.agreement?.assignmentServiceStatus).toLowerCase()}`)
    },
    {
      label: this.trans("dialog/agencyfee-field/newagency-fixedfee-label"),
      value: this.formatter.formatNumber(this.state.agreement?.fixedFee, this.props.app.settings.user.currency)
    },
    {
      label: this.trans("dialog/agencyfee-field/newagency-percentagefee-label"),
      value: `${this.formatter.simpleFormatNumber(this.state.agreement?.percentageFee, false)}%`
    },
    {
      label: this.trans("dialog/defaultchargetemplates-field/period-label"),
      value: this.formatter.checkTranslationType(this.trans(PeriodContainer.pickLabelFromId(this.state?.agreement?.repeatPeriod)), PeriodContainer.pickLabelFromId(this.state?.agreement?.repeatPeriod))
    },
    {
      label: this.trans("dialog/agencyfee-field/fixedpluspercentagemode-label"),
      value: this.formatter.checkTranslationType(this.trans(this.state.agreement?.fixedPlusPercentageMode?.label), this.state.agreement?.fixedPlusPercentageMode?.label)
    }
    ];

    return summaryArr;
  }

  public agreementStep = () => {
    if (this.state.agreement) {
      return (
        <div className="coach-content-wrapper">
          <Title
            title={this.trans("coach/newpropertyfirstuser-step/agreement-info1")}
          />
          <Subtitle
            subtitle={this.trans("coach/general-summary-create-subtitle-dutch-de", { entity: this.trans("title-agreement").toLowerCase() })}
          />
          <CoachSummaryTable
            tableRows={this.agreementStepSummary()}
          />
        </div>
      );
    } else {
      return (
        <div className="coach-content-wrapper">
          <Title
            title={this.trans("coach/newpropertyfirstuser-step/agreement-info1")}
          />
          <Subtitle
            subtitle={this.trans("coach/newpropertyfirstuser-step/agreement-info2")}
          />

          <div>
            <div>
              <div
                style={{
                  marginRight: "15px",
                  color: "gray"
                }}
              >
                {this.trans("dialog/agencyfee-radio/dates-hint")}
              </div>
              <RadioGroup
                name="dateChoice"
                value={this.state.dateChoice}
                onChange={this.changeDateChoice}
                style={{
                  display: "flex",
                  flexDirection: "row"
                }}
              >
                <FormControlLabel
                  value="agreementFirstDate"
                  control={<Radio color="primary" />}
                  label={
                    (<span>{this.trans("dialog/agencyfee-field/firstdate-radiobutton")}</span>)}
                />
                {/* <FormControlLabel
                  value="contractDate"
                  control={<Radio color="primary" />}
                  label={
                    (<span>{this.trans("dialog/agencyfee-field/startfromcontractdate-label")}</span>)}
                /> */}
              </RadioGroup>

              {
                this.state.dateChoice === "agreementFirstDate" && (
                  <DatePickerComponent
                    {...this.props}
                    id="agreementFirstDate"
                    name="agreementFirstDate"
                    className="scroll-to-firstDate"
                    label={this.trans("dialog/agencyfee-field/firstdate-label")}
                    initialDate={this.state.agreementFirstDate}
                    onChange={date => this.selectDate(date, "agreementFirstDate")}
                    clearButton={true}
                    width="250px"
                    error={this.getErrorFor("firstDate") || this.state.firstDateError}
                  />
                )
              }

              <Select
                className="form-element full-size form-input scroll-to-unitTypeId correct-label-position"
                error={this.getErrorFor("assignmentServiceStatusId")}
                value={this.state.assignmentServiceStatus}
                onChange={this.changeAssignmentServiceStatus}
                htmlFor="assignmentServiceStatusId"
                label={this.trans("page/unitupdate-section/info-changeunitservicestatus/label")}
                name="assignmentServiceStatus"
                id="assignmentServiceStatus"
              >
                <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(2).toLowerCase()}`)}</MenuItem>
                <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(5).toLowerCase()}`)}</MenuItem>
                <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(4).toLowerCase()}`)}</MenuItem>
                <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(3).toLowerCase()}`)}</MenuItem>
              </Select>

              <TextField
                autoComplete="off"
                className="form-element full-size scroll-to-fixedFee"
                type="text"
                label={this.trans("dialog/agencyfee-field/newagency-fixedfee-label")}
                value={this.state.fixedFee}
                onChange={this.changeFixedFeeAmount}
                style={{ width: "100%" }}
                autoFocus={true}
                variant="standard"
                error={!!this.getErrorFor("fixedFee")}
                helperText={this.getErrorFor("fixedFee")}
              />

              <TextField
                autoComplete="off"
                className="form-element full-size scroll-to-percentageFee"
                style={{ width: "100%" }}
                type="text"
                label={this.trans("dialog/agencyfee-field/newagency-percentagefee-label")}
                value={this.state.percentageFee}
                onChange={this.changePercentageFeeAmount}
                variant="standard"
                error={!!this.getErrorFor("percentageFee")}
                helperText={this.getErrorFor("percentageFee")}
              />

              <div className="hint-styles">
                {this.trans("dialog/agencyfee-info/percentagefee")}
              </div>

              {parseFloat(this.state?.percentageFee?.replace(",", ".")) > 0 && this.renderChargeTypesSelect()}

              <Select
                className="form-element full-size form-input scroll-to-repeat-period correct-label-position"
                error={this.getErrorFor("repeat-period")}
                disabled={!!this.props.disabled || this.state.assignmentServiceStatus === AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")}
                value={this.state.assignmentRepeatPeriod}
                onChange={this.changeAssignmentPeriod}
                htmlFor="repeatPeriod"
                label={this.trans("dialog/defaultchargetemplates-field/period-label")}
                name="repeatPeriod"
                id="repeatPeriod"
              >
                {this.getRepeatPeriodAgreementSelectboxes(this.state.assignmentServiceStatus)}
              </Select>

              {parseFloat(this.state?.percentageFee?.replace(",", ".")) > 0 && (
                <Select
                  className="form-element full-size form-input scroll-to-fixedPlusPercentageMode correct-label-position"
                  style={{ width: "100%" }}
                  error={this.getErrorFor("fixedPlusPercentageMode")}
                  value={this.state.fixedPlusPercentageMode.id}
                  onChange={this.updateFPPMode}
                  label={this.trans("dialog/agencyfee-field/fixedpluspercentagemode-label")}
                  htmlFor="fixedPlusPercentageMode"
                  name="fixedPlusPercentageMode"
                  id="fixedPlusPercentageMode"
                >
                  {
                    Object.keys(this.props.globalTypes?.FixedPlusPercentageModes || {}).map((fpp) => {
                      let fpps = this.props.globalTypes?.FixedPlusPercentageModes?.[fpp];

                      return (
                        <MenuItem key={fpps.id} value={fpps.id}>{this.formatter.checkTranslationType(this.trans(fpps.label), fpps.label)}</MenuItem>
                      );
                    })
                  }
                </Select>
              )}
            </div>
            <div className="coach-new-property-save-button">
              <Button
                color="primary"
                onClick={this.createAgreement}
                variant="contained"
                style={{ textAlign: "right" }}
              >
                {this.trans("button-save")}
              </Button>
            </div>
          </div>
        </div>
      )
    }
  }

  public tenantStepSummary = () => {
    let summaryArr = [];

    if (this.state.tenantType === "company") {
      summaryArr.push({
        label: this.trans("label-company"),
        value: this.state.companyTenant?.name
      });
    }

    summaryArr.push({
      label: this.trans("label-contact"),
      value: this.state.tenant?.displayName
    });

    if (this.state.occupantsData?.length > 0) {
      this.state.occupantsData?.forEach(occupant => {
        summaryArr.push({
          label: this.trans("new-label-occupant"),
          value: occupant?.selectedPerson?.displayName
        })
      })
    }

    return summaryArr;
  }

  public tenantStep = () => {
    if (this.state.tenant || this.state.companyTenant) {
      return (
        <div className="coach-content-wrapper">
          <Title
            title={this.trans("coach/propertyowner-step/tenant-info1")}
          />
          <Subtitle
            subtitle={this.trans("coach/general-summary-create-subtitle-dutch-de", { entity: this.trans("title-tenant").toLowerCase() })}
          />
          <CoachSummaryTable
            tableRows={this.tenantStepSummary()}
          />
        </div>
      );
    } else {
      return (
        <div className="coach-content-wrapper">
          <Title
            title={this.trans("coach/propertyowner-step/tenant-info1")}
          />
          <Subtitle
            subtitle={this.trans("coach/propertyowner-step/tenant-info2")}
          />

          <div className="image-radio-buttons-container" style={{ marginTop: "-15px" }}>
            <label className="label-wrapper">
              <input
                className="radio-item"
                type="radio"
                value="person"
                name="tenant_type"
                checked={this.state.tenantType === "person"}
                onChange={this.chooseTenantType}
              />
              <div className="label-item">
                {this.image.getImage("coach_person")}
              </div>
              <div className="info-text-gray center">
                {this.trans("coach/propertyowner-radiobutton/person")}
              </div>
            </label>

            <label className="label-wrapper">
              <input
                className="radio-item"
                type="radio"
                value="company"
                name="tenant_type"
                checked={this.state.tenantType === "company"}
                onChange={this.chooseTenantType}
              />
              <div className="label-item">
                {this.image.getImage("coach_company")}
              </div>
              <div className="info-text-gray center">
                {this.trans("coach/propertyowner-radiobutton/company")}
              </div>
            </label>
          </div>
          {
            this.state.tenantType === "person" &&
            <div>
              <div>
                <TextField
                  autoComplete="off"
                  // id="firstName"
                  // name="firstName"
                  className="form-element full-size scroll-to-firstName"
                  type="text"
                  autoFocus={true}
                  label={this.trans("label-first-name")}
                  value={this.state.tenantFirstName}
                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantFirstName")}
                  variant="standard"
                  error={!!this.getErrorFor("firstName") && !this.state.occupantError}
                  helperText={!!this.getErrorFor("firstName") && !this.state.occupantError && this.getErrorFor("firstName")}
                />

                <TextField
                  autoComplete="off"
                  // id="lastName"
                  // name="lastName"
                  className="form-element full-size scroll-to-lastName"
                  type="text"
                  label={this.trans("label-last-name") + this.trans("field/optional")}
                  value={this.state.tenantLastName}
                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantLastName")}
                  variant="standard"
                  error={!!this.getErrorFor("lastName")}
                  helperText={!!this.getErrorFor("lastName") && !this.state.occupantError && this.getErrorFor("lastName")}
                />
              </div>
            </div>
          }
          {
            this.state.tenantType === "company" &&
            <div>
              <div>
                <TextField
                  autoComplete="off"
                  className="form-element full-size"
                  type="text"
                  label={this.trans("coach/propertyowner-scenario/person-step/third-field/companyname-label")}
                  value={this.state.companyNameTenant}
                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "companyNameTenant")}
                  variant="standard"
                  autoFocus={true}
                  error={!!this.getErrorFor("name")}
                  helperText={!!this.getErrorFor("name") && this.state.companyNameTenant.length === 0 ? this.trans("this-field-is-required") : this.getErrorFor("name")}
                />

                <div className="info-text-gray" style={{ marginTop: "15px" }}>
                  {this.trans("coach/newpropertyfirstuser-step/fifth-company-title")}
                </div>
                <TextField
                  autoComplete="off"
                  // id="firstName"
                  // name="firstName"
                  className="form-element full-size scroll-to-firstName"
                  type="text"
                  label={this.trans("label-first-name")}
                  value={this.state.tenantFirstName}
                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantFirstName")}
                  variant="standard"
                  error={!!this.getErrorFor("contacts.firstName")}
                  helperText={!!this.getErrorFor("contacts.firstName") && this.state.tenantFirstName.length === 0 ? this.trans("this-field-is-required") : this.getErrorFor("contacts.firstName")}
                />

                <TextField
                  autoComplete="off"
                  // id="lastName"
                  // name="lastName"
                  className="form-element full-size scroll-to-lastName"
                  type="text"
                  label={this.trans("label-last-name") + this.trans("field/optional")}
                  value={this.state.tenantLastName}
                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantLastName")}
                  variant="standard"
                  error={!!this.getErrorFor("contacts.lastName")}
                  helperText={this.getErrorFor("contacts.lastName")}
                />

                <div className="hint-styles">
                  {this.trans("coach/newpropertyfirstuser-step/fifth-hintfortenant")}
                </div>
              </div>
            </div>
          }
          <div className="coach-new-property-save-button" style={{ marginBottom: "16px" }}>
            <Button
              color="primary"
              onClick={this.createTenant}
              variant="contained"
              style={{ textAlign: "right" }}
            >
              {this.trans("button-save")}
            </Button>
          </div>
          <div>
            <div>
              {this.renderAdditionalFields()}
            </div>
          </div>
          <div className="hint-styles center" style={{ marginTop: "30px", marginBottom: 0 }}>
            {this.trans("coach/newpropertyfirstuser-step/fifth-last-hint")}
          </div>
        </div>
      );
    }
  }

  public renderAdditionalFields = (): any => {
    return (
      <div>
        <div style={{ margin: "20px 0 -5px 0", fontWeight: "bold", fontSize: "16px" }}>
          {this.trans("new-label-occupants")}
          <hr />
        </div>

        {
          this.state.occupantsData?.length > 0 && (
            <div style={{ marginTop: "12px" }}>
              {
                this.state.occupantsData.map((occupant, index) => {
                  return (
                    <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid lightgray" }}>
                      {occupant.error &&
                        <span style={{ position: "absolute", left: "-40px", top: "2px" }}>
                          <span
                            className="icon icon-ic-info red"
                          >
                          </span>
                        </span>
                      }
                      <div style={{ fontSize: "16px" }}>
                        {`${occupant?.selectedPerson?.firstName} ${occupant?.selectedPerson?.lastName || ""} ${occupant?.selectedPerson?.note !== "" ? `, ${occupant?.selectedPerson?.note}` : ""}`}
                      </div>
                      <div style={{ display: "flex", marginTop: "-2px" }}>
                        <span style={{ cursor: "pointer" }} className="icon icon-ic-close clear-button clear-button-list" onClick={() => { this.onClearOccupant(index) }}></span>
                      </div>
                    </div>
                  )
                })
              }
            </div>)
        }

        {!this.state.showAdditionalSection && <div style={{ marginTop: "20px" }}>{this.trans("coach/newcontract-step/tenant-infoadditionaloccupant")}</div>}

        {
          this.state.showAdditionalSection &&
          <div style={{ marginBottom: "-10px" }}>
            <TextField
              autoComplete="off"
              // id="firstName"
              // name="firstName"
              className="form-element full-size scroll-to-firstName"
              type="text"
              label={this.trans("label-first-name")}
              value={this.state.occupantFirstName}
              onChange={this.sync.bind(this, this.syncronizers.EVENT, "occupantFirstName")}
              variant="standard"
              error={!!this.state.occupantError}
              helperText={!!this.state.occupantError && this.trans(this.state.occupantError)}
            />

            <TextField
              autoComplete="off"
              // id="lastName"
              // name="lastName"
              className="form-element full-size scroll-to-lastName"
              type="text"
              label={this.trans("label-last-name") + this.trans("field/optional")}
              value={this.state.occupantLastName}
              onChange={this.sync.bind(this, this.syncronizers.EVENT, "occupantLastName")}
              variant="standard"
              error={!!this.getErrorFor("contacts.lastName")}
            />

            <TextField
              autoComplete="off"
              className="form-element full-size scroll-to-lastName"
              type="text"
              label={this.trans("label-description") + this.trans("field/optional")}
              value={this.state.occupantDescription}
              onChange={this.sync.bind(this, this.syncronizers.EVENT, "occupantDescription")}
              variant="standard"
              error={!!this.getErrorFor("contacts.description")}
            />
          </div>
        }

        <div style={{ display: "flex", alignItems: "baseline", justifyContent: this.state.showAdditionalSection ? "space-between" : "flex-end" }}>
          {
            this.state.showAdditionalSection && (
              <Button
                color="primary"
                onClick={() => {
                  this.clearBackEndErrors();
                  this.setState({ showAdditionalSection: false, occupantError: false, occupantFirstName: "" })
                }}
                style={{ marginRight: "20px" }}
              >
                {this.trans("button-cancel")}
              </Button>
            )
          }

          <div className="coach-new-property-add-button">
            <Button
              color="primary"
              onClick={this.state.showAdditionalSection ? this.addNewOccupant : () => {
                this.setState({ showAdditionalSection: true }, () => {
                  const objDiv = document.getElementById("step-content");
                  objDiv.scrollTop = objDiv.scrollHeight;
                })
              }}
              variant="outlined"
              style={{ textAlign: "right" }}
            >
              {this.state.showAdditionalSection ? this.trans("button-add") : this.trans("coach/newcontract-step/tenant-button/addperson-label")}
            </Button>
          </div>
        </div>
      </div>
    );
  }
  public setChargeTemplateType = (type): void => {

    this.setState({
      type: type,
      repeatPeriod: type === TypeContainer.pickIdFromLabel("Deposit") ? PeriodContainer.pickIdFromLabel("once") : PeriodContainer.pickIdFromLabel("monthly"),
      isCollective: type === TypeContainer.pickIdFromLabel("Deposit")

    })
  }
  public contractStep = () => {
    return (
      <div className="coach-content-wrapper" style={{ width: "650px", maxWidth: "unset" }}>
        <Title
          title={this.trans("coach/newpropertyfirstuser-step/contract-info")}
        />
        <Subtitle
          subtitle={this.trans("coach/newpropertyfirstuser-step/contract-info2")}
        />
        <div style={{ display: "flex", flexDirection: "column", margin: "auto", maxWidth: "500px" }}>
          <DatePickerComponent
            {...this.props}
            id="firstDate"
            name="firstDate"
            style={{ minWidth: "500px" }}
            className="scroll-to-firstDate"
            label={this.trans("first-date") + Time.getDatepickerHint()}
            initialDate={this.state.firstDate}
            onChange={date => this.selectDate(date, "firstDate")}
            clearButton={true}
            additionClasses={"datepicker-error-coach"}
            width="100%"
            error={this.getErrorFor("firstDate")}
          />

          <DatePickerComponent
            {...this.props}
            {...this.getFieldPropsFor("lastDate")}
            label={this.trans("expiration-date") + " 1" + Time.getDatepickerHint() + this.trans("field/optional")}
            initialDate={this.state.lastDate}
            onChange={date => this.selectDate(date, "lastDate")}
            minDate={this.state.firstDate}
            minDatePlusDays={1}
            minDateMessage={this.trans("field/lastfinalenddate-info/error")}
            clearButton={true}
            margin={"7px 0"}
          />

          <DatePickerComponent
            {...this.props}
            {...this.getFieldPropsFor("finalRentalPeriodDate")}
            label={this.trans("expiration-date") + " 2" + Time.getDatepickerHint() + this.trans("field/optional")}
            initialDate={this.state.finalRentalPeriodDate}
            onChange={date => this.selectDate(date, "finalRentalPeriodDate")}
            minDate={this.state.firstDate}
            minDatePlusDays={1}
            minDateMessage={this.trans("field/lastfinalenddate-info/error")}
            clearButton={true}
            margin={"7px 0"}
          />
        </div>

        <Title style={{ marginTop: "30px" }} title={this.trans("coach/newpropertyfirstuser-step/cotract-amounts")} />
        <div style={{ display: "flex", flexDirection: "column" }}>
          {this.state.chargeTemplates?.length > 0 &&

            <ul style={{ margin: 0, padding: 0 }}>
              {
                this.state.chargeTemplates?.map((chargeTemplate, index) => {
                  return (
                    <>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "baseline", width: "100%", marginBottom: "10px" }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "auto", position: "relative" }}>
                          <li style={{ margin: "0", listStyle: "none", fontSize: "16px" }}> {chargeTemplate.error &&
                            <span style={{ position: "absolute", left: "-40px", top: "2px" }}>
                              <span
                                className="icon icon-ic-info red"
                              >
                              </span>
                            </span>
                          }{`${Formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(chargeTemplate.type), {}, "", false), TypeContainer.pickLabelFromId(chargeTemplate.type), chargeTemplate?.type?.system)}, ${this.formatter.formatNumber(chargeTemplate.amount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency))}${chargeTemplate?.isChanged ? ", " : ""}`}
                            {chargeTemplate.isChanged ? <span style={{ color: "green", fontSize: "16px" }}>{this.trans("title-new")}: {this.formatter.formatNumber(chargeTemplate.amount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency))}</span> : ""}
                          </li>
                        </div>
                        <div>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                            <Select
                              className="form-element full-size form-input scroll-to-type correct-label-position"
                              style={{ minWidth: "180px", marginRight: "16px" }}
                              error={this.getErrorFor("type")}
                              value={chargeTemplate?.type}
                              // onChange={(event) => this.setChargeTemplateType(event, index)}
                              htmlFor="type"
                              label={this.trans("dialog/defaultchargetemplates-field/type-label")}
                              name="type"
                              id="type"
                              disabled={true}
                            >
                              {
                                TypeContainer.getChargeTypesForChargeTemplates("contract").map((type, index) => {
                                  return (
                                    <MenuItem key={`chargeType-${index}`} value={type.id} disabled={(type.id === -1 || type.id === -2)}>{`${type.id === -1 || type.id === -2 ? type.label : Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                                  );
                                })
                              }
                            </Select>
                            <div className="form-element full-size no-margins">
                              <TextField
                                autoComplete="off"
                                className="form-element full-size"
                                type="text"
                                label={this.trans("label-amount")}
                                value={chargeTemplate?.amount}
                                // onChange={(event) => this.setNewChargeAmount(event, index)}
                                disabled={true}
                                variant="standard"
                                error={false}

                              />
                            </div>

                            <Select
                              className="form-element full-size form-input scroll-to-currency correct-label-position"
                              error={this.getErrorFor("currency")}
                              style={{ margin: "0 16px", maxWidth: "90px" }}
                              value={chargeTemplate?.currency}
                              htmlFor="currency"
                              label={this.trans("dialog/defaultchargetemplates-field/currency-label")}
                              name="currency"
                              id="currency"
                              disabled={true}
                            >
                              {this.getCurrencySelectboxes()}
                            </Select>

                            <Select
                              className="form-element full-size form-input scroll-to-repeat-period correct-label-position"
                              style={{ maxWidth: "110px" }}
                              error={this.getErrorFor("repeat-period")}
                              value={chargeTemplate?.repeatPeriod}
                              // onChange={(event) => this.setChargeTemplateRepeatPeriod(event, index)}
                              htmlFor="repeatPeriod"
                              label={this.trans("dialog/defaultchargetemplates-field/period-label")}
                              name="repeatPeriod"
                              id="repeatPeriod"
                              disabled={true}
                            >
                              {this.getRepeatPeriodSelectboxes()}
                            </Select>
                            <Button
                              color="primary"
                              onClick={() => { this.onClear(index) }}
                              variant="outlined"
                              style={{ marginLeft: "20px", minWidth: "max-content" }}
                            >
                              {this.trans("button-remove")}
                            </Button>
                          </div>
                        </div>
                      </div>

                    </>
                  )
                })
              }
            </ul>
          }
        </div>
        <div>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", width: "100%" }}>
            <Select
              className="form-element full-size form-input scroll-to-type correct-label-position"
              style={{ minWidth: "180px", marginRight: "16px" }}
              error={this.getErrorFor("type")}
              value={this.state.type}
              onChange={(e) => this.setChargeTemplateType(e.target.value)}
              htmlFor="type"
              label={this.trans("dialog/defaultchargetemplates-field/type-label")}
              name="type"
              id="type"
            >
              {
                TypeContainer.getChargeTypesForChargeTemplates("contract")?.filter(chargeType => {
                  if (!!this.state.type && chargeType.removed && (chargeType.id === this.state.type)) {
                    return true;
                  }
                  if (chargeType.removed) {
                    return false;
                  }
                  return true;
                })
                  .map((type, index) => {
                    return (
                      <MenuItem key={`chargeType-${index}`} value={type.id} disabled={(type.id === -1 || type.id === -2)}>{`${type.id === -1 || type.id === -2 ? type.label : Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                    );
                  })
              }
            </Select>
            <div className="form-element full-size no-margins">
              <TextField
                autoComplete="off"
                // id="amount"
                // name="amount"
                className="form-element full-size scroll-to-amount"
                type="text"
                label={this.trans("dialog/defaultchargetemplates-field/amount-label")}
                value={this.state.amount}
                onChange={this.sync.bind(this, this.syncronizers.EVENT, "amount")}
                autoFocus={true}
                variant="standard"
                error={this.state.errorAmountTemplate}

              />
              {this.state.errorAmountTemplate && <div className="component-error-text">{this.trans("be_ajv_not_validated")}</div>}
            </div>

            <Select
              className="form-element full-size form-input scroll-to-currency correct-label-position"
              style={{ margin: "0 16px", maxWidth: "90px" }}
              error={this.getErrorFor("currency")}
              value={this.state.currency}
              onChange={this.sync.bind(this, this.syncronizers.CURRENCY)}
              htmlFor="currency"
              label={this.trans("dialog/agencyfee-field/currency-label")}
              name="currency"
              id="currency"
              disabled={true}
            >
              {this.getCurrencySelectboxes()}
            </Select>

            <Select
              className="form-element full-size form-input scroll-to-repeat-period correct-label-position"
              style={{ maxWidth: "110px" }}
              error={this.getErrorFor("repeat-period")}
              value={this.state.repeatPeriod}
              onChange={this.sync.bind(this, this.syncronizers.REPEAT_PERIOD)}
              htmlFor="repeatPeriod"
              label={this.trans("dialog/defaultchargetemplates-field/period-label")}
              name="repeatPeriod"
              id="repeatPeriod"
            >
              {this.getRepeatPeriodSelectboxes()}
            </Select>
            <Button
              color="primary"
              onClick={this.addChargeTemplate}
              variant="contained"
              style={{ marginLeft: "20px" }}
            >
              {this.trans("button-save")}
            </Button>
          </div>

          <PaymentRouteRadio
            value={this.state.paymentRouteId}
            onChange={this.switchIsPaidDirectlyToOwner}
            agencyName={this.getAgency()?.name}
            ownerName={this.state.company?.name || this.state.companyName}
          />

          <div style={{ width: "60%" }}>
            <TextField
              autoComplete="off"
              id="referenceForTenant"
              name="referenceForTenant"
              className="form-element full-size scroll-to-referenceForTenant"
              type="text"
              label={this.trans("label-reference-for-tenant") + this.trans("field/optional")}
              value={this.state.referenceForTenant}
              onChange={this.sync.bind(this, this.syncronizers.EVENT, "referenceForTenant")}
              inputProps={{ maxLength: 255 }}
              variant="standard"
              error={!!this.getErrorFor("referenceForTenant")}
            />
          </div>

          <div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.isCommercial}
                  onChange={this.changeIsCommercial}
                  color="primary"
                />
              }
              label={this.trans("page/contracts-label/iscommercialcontract", { vatPercentage: this.props?.app?.settings?.agency?.vatPercentage })}
            />
          </div>

          <div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.autoSendInvoiceToTenant}
                  onChange={this.changeAutoSendInvoiceToTenant}
                  color="primary"
                />
              }
              label={this.trans("page/contracts-label/automaticallysendrentinvoice")}
            />
          </div>

        </div>

      </div>
    );
  }

  //Methods
  public chooseScenario = (event) => {
    const choice: string = event.target.value;

    this.setState({
      scenario: choice,
    });

    if (choice === "multiple") {
      this.setState({
        unitType: UnitTypeContainer.pickIdFromLabel("Room"),
      })
    } else {
      this.setState({
        unitType: UnitTypeContainer.pickIdFromLabel("Apartment"),
      })
    }
  }

  public chooseTenantType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      tenantType: choice,
      tenantFirstName: "",
      tenantLastName: "",
      companyNameTenant: ""
    });
  }

  public chooseOwnerType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      ownerType: choice,
      companyName: ""
    });
  }

  public changeDateChoice = (event: any): void => {
    const choice: string = event.target.value;

    this.setState({
      dateChoice: choice,
      hasModifiedData: true
    });
  }

  public onBlur = () => {
    this.setState({
      companyName: this.state.lastName !== "" ?
        this.state.lastName + this.trans("coach/propertyowner-scenario/person-step/third-field/additionalnameofcompany-label")
        :
        this.state.firstName + this.trans("coach/propertyowner-scenario/person-step/third-field/additionalnameofcompany-label"),
      personDisplayName: `${this.state.firstName} ${this.state.lastName}`
    })
  }

  public updateFPPMode = (event) => {
    const fpp = this.props.globalTypes?.FixedPlusPercentageModes?.[event.target.value];

    this.setState({
      fixedPlusPercentageMode: fpp,
      hasModifiedData: true
    });
  }

  public changeAssignmentServiceStatus = (event) => {
    const type: number = event.target.value;

    this.setState({
      assignmentServiceStatus: type,
      assignmentRepeatPeriod: type === AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch") ? PeriodContainer.pickIdFromLabel("once") : PeriodContainer.pickIdFromLabel("monthly")
    });
  }

  public changeAssignmentPeriod = (event) => {
    const period = event.target.value;

    this.setState({
      assignmentRepeatPeriod: period
    });
  }

  public changePercentageFeeAmount = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    this.setState({
      percentageFee: amount,
      changePercentageFeeManual: true
    });
  }

  public changeFixedFeeAmount = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);
    if (this.state.vat) {
      let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

      let vatNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.vat)).replace(",", ".")).toFixed(2));
      vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

      let varPercentage = vatNumber / (fixedFee - vatNumber) * 100;

      return this.setState({
        vatPercentage: isFinite(varPercentage) ? this.formatter.simpleFormatNumber(Math.round(varPercentage), false, false) : "",
        fixedFee: amount,
        changeFixedFeeManual: true
      });
    }

    if (this.state.vatPercentage) {
      let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

      let vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.vatPercentage)).replace(",", ".")).toFixed(2));
      vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;

      const vatNumber = fixedFee / (100 + vatPercentageNumber) * vatPercentageNumber;

      return this.setState({
        vat: this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false),
        fixedFee: amount,
        changeFixedFeeManual: true
      });
    }

    return this.setState({
      vat: "",
      vatPercentage: "",
      fixedFee: amount,
      hasModifiedData: true
    });
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;
    if (identifier === "agreementFirstDate") {
      this.setState({firstDate: date});
    }
    // Update the state
    this.setState({
      [identifier]: date,
      datepickerHint: "",
      datepickerError: ""
    }, () => {
      // Show the hint if contract period is pretty short, like 5-6 days
      if (!!this.state.firstDate && !!this.state.lastDate &&
        (this.state.lastDate.getTime() - this.state.firstDate.getTime()) <= this.shortContractWarningPeriod) {
        this.setState({
          datepickerHint: this.trans("last-date-of-period-pretty-close")
        });
      }

      // when we change first date we also should syncronize value of last date if it wasn't changed manually
      if (identifier === "firstDate" || identifier === "agreementFirstDate") {
        // we should also update the dates in charge templates
        // Put the current charge templates to the state of the component

        if (this.state.chargeTemplates) {
          this.setState({
            chargeTemplates: this.state.chargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {
              let chargeTemplateFirstDate = chargeTemplate?.firstDate;
              let chargeTemplateDueDateFirstPayment = chargeTemplate?.dueDateFirstPayment;

              if (!!this.state.firstDate && !!chargeTemplate.firstDate) {
                chargeTemplateFirstDate = this.state.firstDate;
              }

              if (!this.state.firstDate && !!chargeTemplate.firstDate) {
                chargeTemplateFirstDate = this.state.firstDate;
              }

              if (!!this.state.firstDate && !chargeTemplate.firstDate) {
                chargeTemplateFirstDate = this.state.firstDate;
              }

              if (!!this.state.firstDate && !!chargeTemplate.dueDateFirstPayment) {
                chargeTemplateDueDateFirstPayment = this.state.firstDate;
              }

              if (!this.state.firstDate && !!chargeTemplate.dueDateFirstPayment) {
                chargeTemplateDueDateFirstPayment = this.state.firstDate;
              }

              if (!!this.state.firstDate && !chargeTemplate.dueDateFirstPayment) {
                chargeTemplateDueDateFirstPayment = this.state.firstDate;
              }

              return {
                ...chargeTemplate,
                firstDate: chargeTemplateFirstDate,
                dueDateFirstPayment: chargeTemplateDueDateFirstPayment
              }
            })
          });
        }

        // we should update last date if it wasn't changed manually
        if (!!this.state.firstDate && !!this.state.lastDate) {
          return this.selectDate(Time.nextYearPrevMonthLastDay(this.state.firstDate), "lastDate");
        }

        if (!this.state.firstDate && !!this.state.lastDate) {
          return this.selectDate(this.state.firstDate, "lastDate");
        }

        if (!!this.state.firstDate && !this.state.lastDate) {
          return this.selectDate(Time.nextYearPrevMonthLastDay(this.state.firstDate), "lastDate");
        }
      }

      // If the identifier is lastDate, we also have to update finalRentalPeriodDate and expirationDate
      // if they were not updated manually
      if (identifier === "lastDate") {
        if (!!this.state.lastDate && !!this.state.finalRentalPeriodDate) {
          this.selectDate(this.state.lastDate, "finalDate");
        }

        if (!this.state.lastDate && !!this.state.finalRentalPeriodDate) {
          this.selectDate(date, "finalDate");
        }

        if (!!this.state.lastDate) {
          this.selectDate(date, "finalDate");
        }

        if (!!this.state.lastDate && !!this.state.expirationDate) {
          return this.selectDate(Time.substractMonth(this.state.lastDate, this.props.app.settings.agency.notificationPeriod), "expirationDate");
        }

        if (!this.state.lastDate && !!this.state.expirationDate) {
          return this.selectDate(this.state.lastDate, "expirationDate");
        }

        if (!!this.state.lastDate) {
          return this.selectDate(Time.substractMonth(this.state.lastDate, this.props.app.settings.agency.notificationPeriod), "expirationDate");
        }
      }
    });
  }

  public createOwner = () => {
    const pageTemplate = "owner";
    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_COMPANY_CREATE_START,
        payload: {
          company: {
            name: this.state.companyName,
            email: "",
            phone: "",
            mainBankAccountId: "",
            address: null,
            amazonFolderName: "",
            note: "",
            pageTemplate: pageTemplate,
            contacts: this.state.ownerType === "person" ? {
              ...this.getPayloadForPerson("person")
            } : undefined
          },
          hideSnackbar: true
        },
        onSuccess: (company) => {
          this.setState({
            company: company,
            showNextButton: true,
            errorFields: [],
            isSaving: false
          })
        },
        onError: (error) => {
          this.setState({
            errorFields: error.fields,
            errorMessage: error.translatedMessage,
            isSaving: false
          })
        }
      });
    });
  }

  public getPayloadForPerson = (type): any => {
    let pageTemplate = type;
    return {
      firstName: type === "tenant" ? this.state.tenantFirstName : this.state.firstName,
      lastName: type === "tenant" ? this.state.tenantLastName : this.state.lastName,
      profession: "",
      email: "",
      phone1: "",
      phone2: "",
      contactRoleId: null,
      mainBankAccountId: "",
      companyId: null,
      address: {
        formattedAddress: ""
      },
      dateOfBirth: null,
      placeOfBirth: {
        formattedAddress: ""
      },
      identityNumber: "",
      identityType: 255,
      amazonFolderName: "",
      note: "",
      pageTemplate: pageTemplate,
      genderTypeId: 3,
      languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
    };
  }

  public createUnit = () => {
    let unit = {
      propertyId: this.state.propertyId,
      unitNumber: this.state.unitNumber,
      unitTypeId: this.state.unitType,
      squareMeters: this.convertToInteger(this.state.squareMeters),
      roomNumber: this.convertToInteger(this.state.roomNumber),
      bedroomNumber: this.convertToInteger(this.state.bedroomNumber),
      bathroomNumber: this.convertToInteger(this.state.bathroomNumber),
      publicationTitle: this.state.publicationTitle,
      amazonFolderName: this.state.amazonFolderName
    }

    if (!this.state.propertyId) {
      unit["address"] = this.state.address;
      unit["companyId"] = this.state.company?.id;
      unit["amazonFolderNameProperty"] = uuidV4();

      if (this.state.scenario === "complex") {
        unit["complexName"] = this.state.complexName;
      }
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_UNIT_CREATE_START,
        payload: {
          unit: unit,
          hideSnackbar: true
        },
        onSuccess: unit => {
          return this.setState({
            unit: unit,
            propertyId: unit?.propertyId,
            errorFields: [],
            showNextButton: true,
            isSaving: false
          }, () => {
            if (this.state.scenario === "complex") {
              this.setState({
                complexUnits: [...this.state.complexUnits, unit]
              })
            }
          });
        },
        onError: err => {
          this.setState({
            errorFields: err.fields,
            errorMessage: err.translatedMessage,
            isSaving: false
          })
        }
      });
    });
  }

  public createAgreement = () => {
    let agreement = {};

    if (!this.state.inheritAgencyFee) {
      agreement = {
        objectId: this.state.unit?.id,
        objectType: this.state.objectType,
        currency: this.state.currency,
        fixedFee: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.fixedFee)).replace(",", ".")).toFixed(2)),
        fixedPlusPercentageMode: this.state.fixedPlusPercentageMode.id,
        percentageFee: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.percentageFee)).replace(",", ".")).toFixed(2)),
        vat: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.vat)).replace(",", ".")).toFixed(2)),
        firstDate: this.state.dateChoice === "agreementFirstDate" ? Time.formatOrNull(this.state.agreementFirstDate) : null,
        lastDate: null,
        chargeTypeIds: this.state.chargeTypeIds,
        repeatPeriodId: this.state.assignmentRepeatPeriod,
        serviceStatusId: this.state.assignmentServiceStatus,
        date: Time.formatOrNull(this.state.dateForAgreement),
      }
    } else {
      agreement = this.state.inheritAgencyFee
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_CREATE_START,
        payload: {
          ...agreement,
          hideSnackbar: true
        },
        onSuccess: createdAgreement => {
          this.props.dispatch({
            type: Constants.GLOBAL_AGENCY_FEE_SIGN_START,
            payload: {
              id: createdAgreement?.id,
              hideSnackbar: true
            },
            onSuccess: signedAgreement => {
              return this.setState({
                agreement: signedAgreement,
                errorFields: [],
                showNextButton: true,
                isSaving: false
              });
            },
            onError: err => {
              this.setState({
                errorFields: err.fields,
                errorMessage: err.translatedMessage,
                isSaving: false
              })
            }
          });
        },
        onError: err => {
          this.setState({
            errorFields: err.fields,
            errorMessage: err.translatedMessage,
            isSaving: false
          })
        }
      });
    });
  }

  public getPayloadTenant = (): any => {
    const pageTemplate = "tenant";

    return {
      person: {
        firstName: this.state.tenantFirstName,
        lastName: this.state.tenantLastName,
        profession: "",
        email: "",
        phone1: "",
        phone2: "",
        contactRoleId: null,
        mainBankAccountId: "",
        companyId: null,
        address: {
          formattedAddress: ""
        },
        dateOfBirth: null,
        placeOfBirth: {
          formattedAddress: ""
        },
        identityNumber: "",
        identityType: 255,
        amazonFolderName: "",
        note: "",
        pageTemplate: pageTemplate,
        genderTypeId: 3,
        languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
      },
      hideSnackbar: true
    };
  }

  public createTenant = () => {
    this.setState({
      occupantError: null //need for clear error for occupant fields
    }, () => {
      if (this.state.tenantType === "person") {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_PERSON_CREATE_START,
            payload: this.getPayloadTenant(),
            onSuccess: person => {
              this.setState({
                isSaving: false,
                errorFields: [],
                tenant: person,
                showNextButton: true
              });
            },
            onError: (error) => {
              this.setState({
                errorFields: error.fields,
                errorMessage: error.translatedMessage,
                isSaving: false
              });
            }
          });
        });
      } else {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_COMPANY_CREATE_START,
            payload: {
              company: {
                name: this.state.companyNameTenant,
                email: "",
                phone: "",
                mainBankAccountId: "",
                address: null,
                amazonFolderName: "",
                note: "",
                pageTemplate: "company",
                contacts: this.state.tenantType === "company" ? {
                  ...this.getPayloadForPerson("tenant")
                } : undefined
              },
              hideSnackbar: true
            },
            onSuccess: (company) => {
              const tenant = PersonFactory.create(company?.data?.contacts?.[0]);

              this.setState({
                companyTenant: company,
                tenant: tenant,
                showNextButton: true,
                errorFields: [],
                isSaving: false,
              })
            },
            onError: (error) => {
              this.setState({
                errorFields: error.fields,
                errorMessage: error.translatedMessage,
                isSaving: false
              })
            }
          });
        });
      }
    })
  }

  public createContract = () => {
    const payload: any = {
      сreatedOnFrontend: true,
      unit: this.state.unit,
      amazonFolderName: this.state.amazonFolderName,
      status: this.state.status,
      firstDate: this.state.firstDate,
      lastDate: this.state.lastDate,
      finalRentalPeriodDate: this.state.finalRentalPeriodDate,
      endDate: this.state.endDate,
      expirationDate: this.state.expirationDate,
      note: this.state.note,
      referenceForTenant: this.state.referenceForTenant,
      chargeTemplates: this.state.chargeTemplates,
      amazonFoldernameTenant: uuidV4(),
      additionalFields: this.state.occupantsData
    };

    if (!!this.state.companyTenant) {
      payload.selectedCompany = this.state.companyTenant;
    } else {
      payload.selectedPerson = this.state.tenant;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CONTRACT_CREATE_START,
        payload: {
          ...payload
        },
        getLabelFor: this.getLabelFor,
        onSuccess: createdContract => {
          this.finishCoach(createdContract);
        },
        onError: (err) => {
          let chargeTemplatesErrorRows = [];

          let chargeTemplatesErrorIndexRows = err.fields.filter(field => field.indexOf("chargeTemplates") === 0)
            .map(field => parseInt(field.match(/\d+/)));

          chargeTemplatesErrorRows.push(chargeTemplatesErrorIndexRows[0]); // just set first error from array
          const chargeTemplates = this.state.chargeTemplates.map((chargeTemplate, index) => {
            return {
              ...chargeTemplate,
              error: chargeTemplatesErrorRows.some(field => field === index)
            }
          })

          this.setState({
            chargeTemplates: chargeTemplates,
            isSaving: false,
            errorFields: err.fields,
            errorMessage: err.translatedMessage,
            scrollToError: ""
          })
        }
      });
    });
  }

  public finishCoach = (contract) => {
    this.setState({
      isSaving: false
    });

    this.onCloseNewPropertyFirstUser();
    this.redirect(`/app/contract/update/${contract?.id}`, true);
  }

  public handleCreatedProperty = (property: PropertyInterface): void => {
    this.setState({
      selectedProperty: property,
      property: property,
      propertyId: property?.id
    });
  }

  public switchIsPaidDirectlyToOwner = (paymentRouteId: PaymentRouteId) => {
    const chargeTemplates = this.state.chargeTemplates.map(template => {
      template.paymentRouteId = paymentRouteId
      return template
    })

    this.setState({
      chargeTemplates,
      paymentRouteId,
    });
  }

  public defaultFixedPlusPercentageModes(label) {
    const chargeClass = this.props.globalTypes?.FixedPlusPercentageModes;
    for (const key in chargeClass) {
      if (chargeClass[key].label === label) {
        return chargeClass[key].id
      }
    }
  }

  public closePreprocessDilaogOpen = () => {
    this.setState({
      isClosePreprocessDialogOpen: false
    });
  }

  public clearProperty = (): void => {
    (this.refs.PropertyLookup as any) && (this.refs.PropertyLookup as any).refs.instance.clear();

    this.setState({
      selectedProperty: null,
      property: null,
      propertyId: null
    });
  }

  public clearBackEndErrors = () => {
    this.setState({
      errorFields: [],
      errorMessage: ""
    });
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public addChargeTemplate = (callback?): any => {
    if (this.state.amount === "" || !this.state.amount?.trim()?.length) {
      return this.setState({
        errorAmountTemplate: true
      });
    }

    const createdChargeTemplate = {
      amount: this.state.amount === "" ? "" : parseFloat(parseFloat(String(Formatter.deleteExtraSpace(this.state.amount)).replace(",", ".")).toFixed(2)),
      currency: this.state.currency,
      repeatPeriod: this.state.repeatPeriod,
      description: this.state.description,
      paymentOffset: this.state.repeatPeriod === PeriodContainer.pickIdFromLabel("once") ? FirstDayOfPeriod.value : this.state.paymentOffset,
      type: this.state.type,
      dueDateFirstPayment: this.state.firstDate,
      firstDate: this.state.firstDate,
      endDate: this.state.endDate,
      isDefault: this.state.isDefault,
      paymentRouteId: this.state.paymentRouteId,
      contactId: !this.state.companyTenant ? this.state.tenant?.id : undefined,
      companyId: this.state.companyTenant?.id,
      isCollective: this.state.repeatPeriod === PeriodContainer.pickIdFromLabel("once") ? false : true,
    }

    const chargeTemplates = [...this.state.chargeTemplates, createdChargeTemplate];

    const reinchargeTemplates = chargeTemplates.map(chargeTemplate => {
      return {
        ...chargeTemplate,
        paymentRouteId: createdChargeTemplate?.isCollective && chargeTemplate?.isCollective ? createdChargeTemplate?.paymentRouteId : chargeTemplate?.paymentRouteId
      }
    })

    this.setState({
      errorAmountTemplate: false,
      chargeTemplates: reinchargeTemplates
    }, () => {
      const type = this.state.chargeTemplates?.find(template => template.type === TypeContainer.pickIdFromLabel("Basic_rent"))
        ? TypeContainer.pickIdFromLabel("Other_receivable")
        : TypeContainer.pickIdFromLabel("Basic_rent")
      this.setState({
        amount: "",
        paymentRouteId: this.state.paymentRouteId,
        currency: this.props.app.settings.user.currency.getCurrencyId(),
        repeatPeriod: this.props.selectedType === TypeContainer.pickIdFromLabel("Deposit") ? PeriodContainer.pickIdFromLabel("once") : PeriodContainer.pickIdFromLabel("monthly"),
        type: type,
        showChargeTemplateFields: false
      }, () => {
        if (typeof callback === "function") {
          callback();
        }
      })
    })
  }

  public onClear = (index) => {
    const chargeTemplates = this.state.chargeTemplates
    chargeTemplates.splice(index, 1);

    this.setState({
      chargeTemplates: chargeTemplates
    })
  }

  public onClearOccupant = (index) => {
    const occupantsData = this.state.occupantsData
    occupantsData.splice(index, 1);

    this.setState({
      occupantsData: occupantsData
    })
  }

  public addNewOccupant = (callback?): any => {
    const occupant = {
      person: {
        firstName: this.state.occupantFirstName,
        lastName: this.state.occupantLastName,
        profession: "",
        email: "",
        phone1: "",
        phone2: "",
        contactRoleId: null,
        mainBankAccountId: "",
        companyId: null,
        address: {
          formattedAddress: ""
        },
        dateOfBirth: null,
        placeOfBirth: {
          formattedAddress: ""
        },
        identityNumber: "",
        identityType: 255,
        amazonFolderName: "",
        note: this.state.occupantDescription,
        pageTemplate: "person",
        genderTypeId: 3,
        languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
      },
      hideSnackbar: true
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_PERSON_CREATE_START,
        payload: occupant,
        onSuccess: occupant => {
          const occupantObj = {
            selectedPerson: occupant,
            description: occupant?.note,
            contactForContractTypeId: OccupantType.contactForContractTypeId
          }
          const occupantsData = [...this.state.occupantsData, occupantObj];

          this.setState({
            isSaving: false,
            errorFields: [],
            occupantsData: occupantsData,
            occupantError: null
          }, () => {
            this.setState({
              occupantFirstName: "",
              occupantLastName: "",
              occupantDescription: this.trans("title-occupant"),
              showAdditionalSection: false
            }, () => {
              if (typeof callback === "function") {
                callback();
              }
            })
          });
        },
        onError: (err) => {
          this.setState({
            isSaving: false,
            errorFields: err.fields,
            errorMessage: err.translatedMessage,
            occupantError: err?.errorId
          });
        }
      });
    });
  }

  public changeAutoSendInvoiceToTenant = () => {
    this.setState({
      autoSendInvoiceToTenant: !this.state.autoSendInvoiceToTenant
    });
  }

  public changeIsCommercial = () => {
    this.setState({
      isCommercial: !this.state.isCommercial
    });
  }

  public render() {
    const steps = this.getSteps();
    return (
      <div>
        <NewCoachWrapper
          state={this.state}
          steps={steps}
          oldCoach={true}
          content={(activeStep) => this.getStepContent(activeStep)}
          openCoach={this.state.openNewPropertyFirstUserCoach}
          onCloseCoach={this.onCloseNewPropertyFirstUser}
          onPageChange={(activeStep, isNext) => {
            isNext && this._handlePageChange(activeStep);
            !isNext && this.setState({ activeStep, isDisabled: false })
          }}
          showBackButton={true}
          disabledNext={
            (this.state.activeStep === 1 && !this.state.company) ||
            (this.state.activeStep === 2 && !this.state.unit) ||
            (this.state.activeStep === 3 && !this.state.agreement) ||
            (this.state.activeStep === 4 && !this.state.tenant) ||
            (this.state.activeStep === 5 && !this.state.chargeTemplates.length)
          }
          useButtonStripForCoach={true}
        />

        <PageTransition isSaving={this.state.isSaving} />

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention")}
          content={
            <div>
              {this.trans("are-you-sure")}
            </div>
          }
          openLeavePrompt={this.state.isClosePreprocessDialogOpen}
          onClose={this.closePreprocessDilaogOpen}
          onlyPositiveButton={true}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={false}
          hideCross={true}
          actions={
            [
              (
                <Button
                  key="modal-cancel-btn"
                  color="primary"
                  onClick={this.closePreprocessDilaogOpen}
                  style={{ height: "34px", width: "auto" }}
                >
                  {this.trans("label-no")}
                </Button>
              ),
              (
                <Button
                  key="modal-add-btn"
                  variant="contained"
                  color="primary"
                  onClick={this.onCloseNewPropertyFirstUser}
                  style={{ height: "34px", width: "auto" }}
                >
                  {this.trans("label-yes")}
                </Button>
              )
            ]
          }
        />
      </div>
    );
  }
}
